import { useState, useCallback } from 'react';
import { c209Api, FJ710 } from '../../../services/c209Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record */
  const resolveAllNames = useCallback(async (data: Partial<FJ710>) => {
    const entries: [string, string, string][] = [
      ['department', 'department', data.fj710_13 || ''],
      ['sellCurrency', 'currency', data.fj710_161 || ''],
      ['costCurrency', 'currency', data.fj710_171 || ''],
      ['extraCurrency', 'currency', data.fj710_191 || ''],
      ['remarkCode', 'remark', data.fj710_231 || ''],
      ['rdReplyCode', 'remark', data.fj710_251 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        c209Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) [T-F04] */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await c209Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
